import { useId, useState } from 'react';
import { inputClassName, labelClassName } from '../ui/classes';

const STEPS = [
  'Seller Central → Settings → Account Info',
  'Business Information → Merchant Token',
  'Copy the Merchant Token and paste it below',
];

function SpApiSellerIdField({ value, onChange, required = true, placeholder = 'AXXXXXXXXXXXXX' }) {
  const [showHelp, setShowHelp] = useState(false);
  const helpId = useId();

  return (
    <label className="grid gap-1.5">
      <span className={`${labelClassName} flex items-center justify-between gap-2`}>
        <span>Seller ID</span>
        <button
          type="button"
          className="text-xs font-medium text-slate-500 hover:text-slate-800"
          aria-expanded={showHelp}
          aria-controls={helpId}
          onClick={() => setShowHelp((current) => !current)}
        >
          {showHelp ? 'Hide help' : 'Where to find'}
        </button>
      </span>

      {showHelp ? (
        <div
          id={helpId}
          className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5 text-xs leading-relaxed text-slate-600"
        >
          <ol className="list-decimal space-y-1 pl-4">
            {STEPS.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      ) : null}

      <input
        className={`${inputClassName} min-h-11 rounded-xl`}
        name="sellerId"
        type="text"
        autoComplete="off"
        spellCheck={false}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
      />
    </label>
  );
}

export default SpApiSellerIdField;
